import paths from 'constants/paths'
import Link from 'next/link'
import styles from './CTAButton.module.scss'

type CTAButtonProps = {
  text: string
  background?: 'light' | 'dark'
}

const CTAButton = ({ text, background = 'light' }: CTAButtonProps) => {
  return (
    <Link href={paths.contact}>
      <button className={styles['cta-button'] + ' ' + styles[background]}>{text}</button>
    </Link>
  )
}

export default CTAButton
